import { gql } from '@apollo/client';

export interface MembershipV2 {
  organisation: string;
  roles: string[];
}

export interface AddMembershipInputV2 {
  id: string;
  memberships: MembershipV2[];
}

export interface AddMembershipResponseDataV2 {
  addMembershipV2: {
    message: string;
  };
}

export const ADD_MEMBERSHIP_V2 = gql`
  mutation addMembershipV2($input: AddMembershipInputV2!) {
    addMembershipV2(input: $input)
  }
`;
